import { ApiCategory } from 'idt-ecommerce-api/_api/api-catalog/api-categories/api-categories.models';
import { ApiProduct } from 'idt-ecommerce-api/_api/api-catalog/api-products/api-products.models';
import { ApiPhysicalStoreOpeningHours } from 'idt-ecommerce-api/_api/api-catalog/api-stores/api-stores.models';
import { CategoryAnalytics } from 'idt-ecommerce-api/catalog/categories/categories.models';
import { MediaClazz } from 'idt-ecommerce-api/catalog/products/medias/medias.models';
import { Product } from 'idt-ecommerce-api/catalog/products/products.models';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { PhysicalStoreSchedule } from 'idt-ecommerce-api/stores/stores.models';
import { MetaTag } from 'shared/models/meta-tags.models';

/** Representa la configuración del módulo de itd-ecommerce-api */
export interface EcommerceConfig {
  apiBaseUrl: string;
  brandCode?: string;
  colorIdParamName?: string;
  appId: AppIdEnum;
  brandSettings: EcommerceBrandSettings;
  catalogType: string;
  instanceType: 'cms' | 'render';
  providers: EcommerceConfigProviders;
  timestampBuildVersion?: string;
}

export interface EcommerceConfigProviders {
  cmsConfigurationsBaseUrl?: string;
  cmsConfigurationsStaticBaseUrl?: string;
  cmsTranslationsBaseUrl?: string;
  cmsTranslationsStaticBaseUrl?: string;
  cmsCollectionsBaseUrl?: string;
  cmsCollectionsStaticBaseUrl?: string;
  colbensonSearchUrl?: string;
}

/** Enumerado numérico que representa las distintas plafaformas soportadas por ecommerce */
export enum AppIdEnum { web = 1, ios = 3, android = 4, store = 7 }

/** Interfaz que define las variables y métodos que no pueden tratarse de forma común en todas las cadenas */
export interface EcommerceBrandSettings {

  // --- Constants ---
  brandId: string;
  brandName: string;
  mediaPathSuffix: string;

  // --- Functions ---

  /** Función que sobreescribe el mapeo de clazz de un media (ej. clazz 1 = foto principal (main)
   *  Si está definida, se aplica inmediatamente después de la función de parseo común (parseMediaClazz)
   */
  parseMediaClazzOverride?: (apiClazz: number) => MediaClazz;

  /** Función que reordena el listado de categorías en crudo para tratar las particulares concretas de las cadenas que necesiten
   * reordenar o "retocar" el listado recibido por Gesticor.
   * Si está definida, se aplica antes realizarse el parseo y filtrado de categorías.
   * Se puede usar esta función para crear nodos fake si es necesario.
   */
  reorderApiCategories?: ((apiCategories: ApiCategory[]) => ApiCategory[]);

  /** Función para transformar el horario de una tienda */
  schedulesFromApi?: ((openingHours?: ApiPhysicalStoreOpeningHours, context?: EcommerceContext) => PhysicalStoreSchedule[]);

  /** Función que reemplaza la lista de relacionados de un producto con las particularidades especificas de una cadena.
   *  Si está definida, se ejecuta antes de el transformer de producto).
   */
  transformProductWithMocacos?: ((productDetail: ApiProduct, mocacos: ApiProduct[]) => ApiProduct);

  /** Función que configura la gestión de cookies con las particularidades específicas de una cadena.
   * Si está definida, se aplica al renderizar la página
   */
  setCookies?: (document: Document) => void;

  /** Función que obtiene el texto de SEO correspondiente a la clave introducida como parámetro.
   *  Dicho texto se parsea sustituyendo los comodines por sus valores correspondientes
   */
  obtainParsedSEOText?: (key: string, context: EcommerceContext, product?: Product, category?: CategoryAnalytics) => string;

  /** Función que obtiene las metas por defecto para cierto tipo de página pasado como parámetro.
   * Si está definida se aplica al seleccionar un tipo de página desde el CMS
   */
  obtainDefaultMetaTags?: (pageType: string) => MetaTag[];
}
